document.querySelectorAll(".video-component").forEach(function (el) {
    let media = el.querySelector("iframe") || el.querySelector("embed");
    if (!media) {
        return;
    }

    let videoSrc = media.getAttribute("src");
    if (!videoSrc) {
        return;
    }

    let url = new URL(videoSrc, window.location.href);

    // as=1 query param makes the video autoplay
    if (videoSrc.includes("as=1")) {
        url.searchParams.delete("as", 1);
        media.setAttribute("src", url.toString());
    }

    let playToggle = el.querySelector("[data-play-toggle]");
    if (playToggle) {
        playToggle.addEventListener("click", (ev) => {
            ev.preventDefault();
            url.searchParams.set("as", 1);
            media.setAttribute("src", url.toString());
            el.classList.add('playing');
            playToggle.classList.add('playing');
        });
    }
});